import React from 'react';
import Books from '../../components/books/Books';
import Preloader from '../../components/common/Preloader';
import MetaComponent from '../../components/common/MetaComponent';

const metadata = {
  title: "Books || GVK Student Portal",
  description: "Browse our collection of best-selling books for competitive pharmacy exams. State-wise and PAN-India preparation books available.",
};

const BooksPage = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <Preloader />
      <Books />
    </>
  );
};

export default BooksPage;

